@if (parameters$ | async; as parameters) {
	<section class="survey-container flex">
		<div class="wrap-monologue">
			<img src="assets/images/monologue-survey.svg" alt="monologue-survey" />
		</div>
		<div class="wrap-survey flex">
			<p class="text question" [innerHTML]="parameters.surveyBanner"></p>
			<button
				bciWkButtonWithIcon
				[iconName]="'comment'"
				class="flex"
				(click)="onShowSurvey(parameters.idFeedbackSurvey)"
			>
				Danos tu opinión
			</button>
		</div>
	</section>
}
